import config from 'config/config'
import { I18n } from 'lib/i18n'
import { del, get, post, put } from 'lib/utilities'
import { push } from 'react-router-redux'
import { toast } from 'react-toastify'
import { initialize } from 'redux-form'
import { Observable } from 'rxjs'

// TODO: This is a copy of catagories. adapt rails and clean up the mess here

export const LOAD = 'route/LOAD'
export const LOAD_DONE = 'route/LOAD_DONE'
export const LOAD_FAILED = 'route/LOAD_FAILED'
export const LOAD_TREE = 'route/LOAD_TREE'
export const LOAD_TREE_DONE = 'route/LOAD_TREE_DONE'
export const LOAD_TREE_FAILED = 'route/LOAD_TREE_FAILED'
export const LOAD_BREADCRUMBS = 'route/LOAD_BREADCRUMBS'
export const LOAD_BREADCRUMBS_DONE = 'route/LOAD_BREADCRUMBS_DONE'
export const LOAD_BREADCRUMBS_FAILED = 'route/LOAD_BREADCRUMBS_FAILED'
export const UPDATE = 'route/UPDATE'
export const TOGGLE_NODE = 'route/TOGGLE_NODE'
export const MOVE_NODE = 'route/MOVE_NODE'
export const SAVE_TREE_DONE = 'route/SAVE_TREE_DONE'
export const SAVE_TREE_FAILED = 'route/SAVE_TREE_FAILED'

export const LOAD_ROUTE = 'route/LOAD_ROUTE'
export const LOAD_ROUTE_DONE = 'route/LOAD_ROUTE_DONE'
export const LOAD_ROUTE_FAILED = 'route/LOAD_ROUTE_FAILED'
export const CREATE_ROUTE = 'route/CREATE_ROUTE'
export const CREATE_ROUTE_DONE = 'route/CREATE_ROUTE_DONE'
export const CREATE_ROUTE_FAILED = 'route/CREATE_ROUTE_FAILED'
export const SAVE_ROUTE = 'route/SAVE_ROUTE'
export const SAVE_ROUTE_DONE = 'route/SAVE_ROUTE_DONE'
export const SAVE_ROUTE_FAILED = 'route/SAVE_ROUTE_FAILED'
export const DELETE_ROUTE = 'route/DELETE_ROUTE'
export const DELETE_ROUTE_DONE = 'route/DELETE_ROUTE_DONE'
export const DELETE_ROUTE_FAILED = 'route/DELETE_ROUTE_FAILED'

// action creators
export const loadProductRoutes = () => ({ type: LOAD })
export const loadFulfilled = (routes) => ({ type: LOAD_DONE, routes })
export const loadFailed = () => ({ type: LOAD_FAILED })

export const loadTree = () => ({ type: LOAD_TREE })
export const loadTreeFulfilled = (tree) => ({ type: LOAD_TREE_DONE, tree })
export const loadTreeFailed = () => ({ type: LOAD_TREE_FAILED })

export const loadBreadcrumbs = () => ({ type: LOAD_BREADCRUMBS })
export const loadBreadcrumbsFulfilled = (routes) => ({
  type: LOAD_BREADCRUMBS_DONE,
  routes,
})
export const loadBreadcrumbsFailed = (errors) => ({
  type: LOAD_BREADCRUMBS_FAILED,
  errors,
})

export const changeTree = (tree) => ({ type: UPDATE, tree: tree })
export const toggleNode = (request) => ({ ...request, type: TOGGLE_NODE })
export const moveNode = (request) => {
  let subject = request.path.pop()
  let [subjectId, nodePosition] = subject.split('/')
  if (request.path.length === 0)
    return {
      ...request,
      type: MOVE_NODE,
      movement: {
        id: parseInt(subjectId, 10),
        parent_id: 0,
        position: parseInt(nodePosition, 10),
      },
    }

  let parent = request.path.pop()
  let [parentId, parentPosition] = parent.split('/')
  return {
    ...request,
    type: MOVE_NODE,
    movement: {
      id: parseInt(subjectId, 10),
      parent_id: parseInt(parentId, 10),
      position: nodePosition - parentPosition - 1,
    },
  }
}
export const saveTreeFulfilled = () => ({ type: SAVE_TREE_DONE })
export const saveTreeFailed = (error) => ({ type: SAVE_TREE_FAILED })

export const createRoute = (newRoute) => ({ type: CREATE_ROUTE, newRoute })
export const createRouteFulfilled = () => ({ type: CREATE_ROUTE_DONE })
export const createRouteFailed = () => ({ type: CREATE_ROUTE_FAILED })

export const saveRoute = (route) => ({ type: SAVE_ROUTE, route: route })
export const saveRouteFulfilled = () => ({ type: SAVE_ROUTE_DONE })
export const saveRouteFailed = () => ({ type: SAVE_ROUTE_FAILED })

export const deleteRoute = (id) => ({ type: DELETE_ROUTE, id })
export const deleteRouteFulfilled = () => ({ type: DELETE_ROUTE_DONE })
export const deleteRouteFailed = () => ({ type: DELETE_ROUTE_FAILED })

export const loadRoute = (id) => ({ type: LOAD_ROUTE, id })
export const loadRouteFulfilled = (route) => ({ type: LOAD_ROUTE_DONE, route })
export const loadRouteFailed = () => ({ type: LOAD_ROUTE_FAILED })

const initialState = {
  activeTreeNode: null,
  treeLoading: false,
  tree: [],
  routes: [],
  route: null,
  newRoute: null,
  newRouteModalVisible: false,
}

// TODO: finish namespacing actions
export const routesReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD:
      return { ...state, routesLoading: true }
    case LOAD_DONE:
      return { ...state, routesLoading: false, routes: action.routes }
    case LOAD_TREE:
      return { ...state, treeLoading: true }
    case LOAD_TREE_DONE:
      return { ...state, tree: action.tree, treeLoading: false }
    case LOAD_BREADCRUMBS:
      return { ...state, routesLoading: true }
    case LOAD_BREADCRUMBS_DONE:
      return { ...state, routesLoading: false, routes: action.routes }
    case LOAD_BREADCRUMBS_FAILED:
      return { ...state, routesLoading: false }
    case TOGGLE_NODE:
      return { ...state, tree: action.treeData }
    case MOVE_NODE:
      return { ...state, tree: action.treeData }
    case SAVE_TREE_FAILED:
      return { ...state, error: action.error }
    case LOAD_ROUTE:
      return { ...state, routeLoading: true }
    case LOAD_ROUTE_DONE:
      return { ...state, route: action.route, routeLoading: false }
    case CREATE_ROUTE:
      return { ...state, newRoute: action.newRoute }
    case CREATE_ROUTE_DONE:
      return { ...state, routeSaved: true, newRouteModalVisible: false }
    case SAVE_ROUTE:
      return { ...state, modifiedRoute: action.route }
    case SAVE_ROUTE_DONE:
      return { ...state, routeSaved: true, route: state.modifiedRoute }
    case DELETE_ROUTE:
      return { ...state, deletingRoute: true }
    case DELETE_ROUTE_DONE:
      return { ...state, deletingRoute: false }
    default:
      return state
  }
}

export const loadEpic = (action$, store) =>
  action$
    .ofType(LOAD)
    .mergeMap((action) => get('/routes.json'))
    .mergeMap((result) => {
      if (result.ok) {
        return [loadFulfilled(result.body)]
      } else {
        toast.error(I18n.t('action.routes/LOAD_ROUTES_FAILED'))
        return [loadFailed(result.body.errors)]
      }
    })

export const loadTreeEpic = (action$, store) =>
  action$
    .ofType(LOAD_TREE)
    .mergeMap((action) => get('/product_route_tree.json'))
    //.mergeMap(action => get(':3003/product_route_tree', 'http://127.0.0.1'))
    .mergeMap((result) => {
      if (result.ok) {
        return [loadTreeFulfilled(result.body)]
      } else {
        toast.error(I18n.t('action.routes/LOAD_TREE_FAILED'))
        return [loadTreeFailed(result.body.errors)]
      }
    })

export const saveEpic = (action$, store) =>
  action$
    .ofType(MOVE_NODE)
    .mergeMap((action) =>
      put('/routes/move.json', { movement: action.movement })
    )
    .mergeMap((result) => {
      if (result.ok) {
        return [saveTreeFulfilled()]
      } else {
        toast.error(I18n.t('action.routes/SAVE_TREE_FAILED'))
        return [saveTreeFailed(result.body.errors)]
      }
    })

export const toggleNodeEpic = (action$, store) =>
  action$
    .ofType(TOGGLE_NODE)
    .mergeMap((action) =>
      put('/routes/visibility.json', {
        visibility: { id: action.node.id, expanded: action.expanded },
      })
    )
    .mergeMap((result) => {
      if (result.ok) {
        return [saveTreeFulfilled()]
      } else {
        toast.error(I18n.t('action.routes/SAVE_TREE_FAILED'))
        return [saveTreeFailed(result.body.errors)]
      }
    })

export const loadBreadcrumbsEpic = (action$, store) =>
  action$
    .ofType(LOAD_BREADCRUMBS)
    .mergeMap((action) => get('/routes/breadcrumbs.json'))
    .mergeMap((result) => {
      if (result.ok) {
        return [loadBreadcrumbsFulfilled(result.body)]
      } else {
        toast.error(I18n.t('action.routes/LOAD_BREADCRUMBS_FAILED'))
        return [loadBreadcrumbsFailed(result.body.errors)]
      }
    })

export const loadRouteEpic = (action$, store) =>
  action$
    .ofType(LOAD_ROUTE)
    .mergeMap((action) => get(`/routes/${action.id}.json`))
    .mergeMap((result) => {
      if (result.ok) {
        const route = result.body
        const properties = route.property_filters
          .map((filter) => {
            const { id, property_id, is_filter } = filter
            return { id, property_id, is_filter }
          })
          .concat(
            new Array(5 - route.property_filters.length)
              .fill()
              .map(() => ({ property_id: -1, is_filter: false }))
          )

        const productIds = route.products.map((product) => product.id)
        return [
          // TODO: @andreas – review, DOM / Browser interaction - better in componentWillMount?
          push(`${config.nodes.routes}${route.id}`),
          loadRouteFulfilled(route),
          // TODO: Call this only when needed, not always
          initialize('route_details', {
            title_de: route.title_de,
            title_fr: route.title_fr,
            properties: properties,
            productIds: productIds,
            headerMediumId: route.header_image_id,
            thumbnailMediumId: route.thumbnail_id,
          }),
        ]
      } else {
        toast.error(I18n.t('action.routes/LOAD_ROUTES_FAILED'))
        return [loadFailed(result.body.errors)]
      }
    })

export const createRouteEpic = (action$, store) =>
  action$
    .ofType(CREATE_ROUTE)
    .mergeMap((action) => {
      const route = action.newRoute
      return post('/product_routes.json', {
        product_route: {
          title_de: route.title_de,
          title_fr: route.title_fr,
          parent_id: route.parent_id,
          link_target_id: route.type === 'virtual' && route.link_target_id,
        },
      })
    })
    .mergeMap((result) => {
      return Observable.concat(
        Observable.of(loadTree()),
        Observable.of(createRouteFulfilled())
      )
    })

export const deleteRouteEpic = (action$, store) =>
  action$
    .ofType(DELETE_ROUTE)
    .mergeMap((action) => del(`/product_routes/${action.id}.json`))
    .mergeMap((result) => {
      if (result.ok) {
        return [loadTree()]
      } else {
        toast.error(I18n.t('action.routes/DELETE_ROUTE_FAILED'))
        return [deleteRouteFailed(result.body.errors)]
      }
    })

export const saveRouteEpic = (action$, store) =>
  action$
    .ofType(SAVE_ROUTE)
    .mergeMap((action) => put('/product_route.json'))
    //.mergeMap(action => put(':3003/routes/' + action.route.id, action.route, 'http://127.0.0.1'))
    .mergeMap((result) => {
      if (result.ok) {
        return [loadTree(), saveRouteFulfilled()]
      } else {
        toast.error(I18n.t('action.routes/CREATE_ROUTE_FAILED'))
        return [createRouteFailed(result.body.errors)]
      }
    })



// WEBPACK FOOTER //
// ./src/redux/routes.js